import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import ml from "./locales/ml/translation.json";
import hi from "./locales/hi/translation.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ml: { translation: ml },
      hi: { translation: hi }
    },

    // 👇 USE IT HERE
    lng: localStorage.getItem("lang") || "ml",

    fallbackLng: "ml",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
